// extracted by mini-css-extract-plugin
export default {"balance":"cpiVM","balance-name":"uKdTY","extended":"a0nVu"};